
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import vCardsJS from 'vcards-js';
import {
  PRIVATE_KEY,
  SYMMETRIC_KEY,
  SYMMETRIC_KEY_ENCRYPTED,
  API_KEY
} from '../config/config';

import { saveAs } from 'file-saver';


export const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(data, SYMMETRIC_KEY).toString();
  return encrypted;
};

export const decrypt = (encryptedData) => {
  const decrypter = new JSEncrypt();
  decrypter.setPrivateKey(PRIVATE_KEY);
  const decryptedKey = decrypter.decrypt(SYMMETRIC_KEY_ENCRYPTED);
  const bytes = CryptoJS.AES.decrypt(encryptedData, decryptedKey);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
};

export const fetchURL = url => new Promise((resolve) => {

  fetch(url, {
    method: "GET",
    headers: {
      "access-control-allow-origin": "*",
      "Content-type": "text/plain; charset=UTF-8"
    }
  })
    .then((response) => {
      return response.text();
    })
    .then((data) => {
      resolve(data);
    })
});

export const getFileBase64 = (url) => new Promise((resolve) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
});

export const getCard = async (url) => {
  const encrypted = await fetchURL(url);
  try {
    const card = JSON.parse(decrypt(encrypted));
    return card;
  } catch (e) {
  }
}

export const geoCodeAddress = async (addressUrl) => {
  if (addressUrl) {
    const response = await fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + addressUrl + "&key=" + API_KEY, { method: "GET" });
    const addressResponse = await response.json();
    console.log(addressResponse);
    if (addressResponse.status === "OK") {
      return addressResponse.results[0];
    }
    return null;
  }
}

export const getAddressComponent = (component, address_components) => {
  if(address_components){
      for (const address_component of address_components.address_components) {
          if (address_component.types.includes(component)) {
              return address_component.long_name;
          }
      }
  }
  return null;
}

export const downloadVCard = async (url) => {
  const card = await getCard(url);

  var vCard = vCardsJS();

  //set properties
  const names = card.name.split(' ');
  let firstName = '';
  let lastName = '';

  for (let [index, nameSegment] of names.entries()) {
    if (index < names.length - 1) {
      firstName = firstName + index != 0 ? " " : "" + nameSegment;
    } else {
      lastName = nameSegment;
    }
  }


  vCard.uid = card.id;
  vCard.formattedName = card.name;
  vCard.organization = card.businessName;
  vCard.photo.attachFromUrl(`https://storage.googleapis.com/biztap_images/${card.imageFolder}/front.png`, 'PNG');
  vCard.logo.attachFromUrl(`https://storage.googleapis.com/biztap_images/${card.imageFolder}/front.png`, 'PNG');
  vCard.homePhone = card.cellphone;
  vCard.cellPhone = card.cellphone;
  vCard.workUrl = card.website;
  vCard.url = 'https://www.biztap.io/';
  vCard.email = card.email;
  vCard.workEmail = card.email;
  vCard.note = 'Contact created by Biztap. Visit for more info https://biztap.io';

  const address = await geoCodeAddress(card.address);

  vCard.workAddress.label = card.businessName + ' Address';
  vCard.workAddress.street = getAddressComponent('street_number', address) + " " + getAddressComponent('route', address);
  vCard.workAddress.city = getAddressComponent('sublocality', address);
  vCard.workAddress.stateProvince = getAddressComponent('administrative_area_level_1', address);
  vCard.workAddress.postalCode = getAddressComponent('postal_code', address);
  vCard.workAddress.countryRegion = getAddressComponent('country', address);

  console.log(vCard);

  const blob = new Blob([vCard.getFormattedString()], { type: "text/vcard" });

  saveAs(blob, 'biztap.vcf');
  //fileDownload(vCard.getFormattedString(), 'biztap.vcf');
}
